export const colorPrimary = '#5D73A1';
export const colorSecondary = '#263a65';
